import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NuestraEmpresaComponent } from './nuestra-empresa.component';


@NgModule({
  declarations: [ NuestraEmpresaComponent ],
  imports: [
    CommonModule,
  ],
  exports: [ NuestraEmpresaComponent ],
})
export class NuestraEmpresaModule { }
